import Logger from '@/utils/Logger';
import { TencentBrowserEventTracker } from '@sasan/event-tracker';

const EventTracker = process.env.TENCENT_CLOUD_CLS_ENDPOINT
  ? new TencentBrowserEventTracker({
      projectId: 'sasan-courseware',
      topicId: process.env.TENCENT_CLOUD_CLS_TOPIC_ID!,
      endpoint: process.env.TENCENT_CLOUD_CLS_ENDPOINT,
      logger: Logger,
      debug: process.env.EVENT_TRACKER_DEBUG === 'true',
    })
  : {
      collectEvent() {},
      setUser() {},
    };

export default EventTracker;
